import { Component, OnInit, Input, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppService } from 'src/app/app.service';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { NgxFileDropEntry, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { LoadMediaService } from 'src/app/loadmedia.service';

@Component({
  selector: 'app-media-list',
  templateUrl: './media-list.component.html',
  styleUrls: ['./media-list.component.scss']
})
export class MediaListComponent implements OnInit {

  fileToUpload: File = null;
  public files: NgxFileDropEntry[] = [];
  searchText: string;
  resourceid: number;
  store_id: any;
  resource_type_id: any = 1;
  visible_data: boolean = false;
  viewMode: 'grid' | 'list' = 'grid';

  page_first_result: number = 0;
  result_per_page: number = 50;
  public counts = [50, 100, 150, 200, 250, 300];
  public count: any = this.counts[0];
  rowCount: any = 0;
  page: any = 1;
  medialoader: boolean;

  constructor(public http: HttpClient, public snackBar: MatSnackBar, public dialog: MatDialog, public appService: AppService, public mediaService: LoadMediaService) {
    this.loadMedias();
  }

  loadMedias() {
    // Ensure we are using correct pagination values for the service
    this.mediaService.loadMedias();
  }


  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
  }

  addToSelectedIMG(image, isChecked: boolean) {
    if (isChecked) {
      if (!this.appService.Data.selectedIMG.includes(image)) {
        this.appService.Data.selectedIMG.push(image);
      }
    } else {
      let index = this.appService.Data.selectedIMG.indexOf(image)
      if (index !== -1) {
        this.appService.Data.selectedIMG.splice(index, 1);
      }
    }
  }

  getImages() {
    this.page = 1;
    this.page_first_result = 0;
    this.loadMedias();
  }

  public changeCount(count) {
    this.count = +count; // Ensure number
    this.page = 1;
    this.page_first_result = 0;
    this.result_per_page = this.count;
    this.loadMedias();
  }

  public onPageChanged(event) {
    // Handle both number (from controls) or event (from pagination pipe if used, though strict mode avoids it)
    // Here we support manual input (ENTER key) or button click
    let newPage = +event;

    // Validate Bounds
    const maxPage = Math.ceil(this.rowCount / this.count) || 1;
    if (newPage < 1) newPage = 1;
    if (newPage > maxPage) newPage = maxPage;

    this.page = newPage;
    this.page_first_result = (this.page - 1) * this.count;
    this.result_per_page = this.count;
    this.loadMedias();
  }

  public dropped(files: NgxFileDropEntry[]) {
    this.files = files;
    for (const droppedFile of files) {
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          // File logic
        });
      }
    }
  }

  public fileOver(event) { }
  public fileLeave(event) { }

  ngOnInit() { }

  openDeleteComponent(resource_id) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "400px",
      data: {
        title: "Confirm Action",
        message: "Are you sure you want delete ?",
        buttonName1: "No",
        buttonName2: "Yes",
      }
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.appService.deleteImage(resource_id).subscribe(data => {
          if (data.resource_id > 0) {
            this.snackBar.open('Deleted Image successfully!', '×', { panelClass: 'success', verticalPosition: 'top', duration: 3000 });
            this.loadMedias();
          }
        }, error => {
          if (error.error.status) {
            this.appService.signOut();
          }
        })
      }
    });
  }

  copyLink(url: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = url;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.snackBar.open('Link copied to clipboard!', '×', { panelClass: 'success', verticalPosition: 'top', duration: 3000 });
  }

}
